export const urlHome = () => `/`;
//
//
// Auth URLs
export const urlLogin = () => `/login`;
export const urlSignup = () => `/signup`;
//
//
// Profile URLs
export const urlProfile = (id: string) => `/club/${id}/perfil`;
//
//
// Main sidebar URLs
export const urlControlPanel = (id: string) => `/club/${id}`;
export const urlCourt = (id: string, courtId: string) => `/club/${id}/canchas/${courtId}`;
export const urlCourtList = (id: string) => `/club/${id}/canchas`;
//
//
// Config URLs
export const urlConfig = (id: string, tab?: string) => `/club/${id}/gestion${tab ? `/${tab}` : ''}`;
//
//
// Court URLs
export const urlCourtReservations = (id: string, courtId: string, date?: string) =>
  `/club/${id}/canchas/${courtId}/reservations${date ? `/${date}` : ''}`;
//
//
// Tournament URLs
export const urlTournamentList = (id: string) => `/club/${id}/torneos`;
export const urlNewTournament = (id: string) => `/club/${id}/torneos/nuevo`;
export type TournamentTab =
  'inscriptos' | 'grupos' | 'cuadro' | 'estado' | 'franjas' | 'datos' | 'categorias';
export const urlTournament = (id: string, tournamentId: string, tab?: TournamentTab) =>
  `/club/${id}/torneos/${tournamentId}${tab ? `/${tab}` : ''}`;
export const urlTournamentPrint = (id: string, tournamentId: string) =>
  `${urlTournament(id, tournamentId)}/imprimir`;
//
//
// Ranking URLs
export const urlRanking = (id: string) => `/club/${id}/ranking`;
//
//
// Public Tournament URLs
export const urlPublicTournament = (id: string) => `/torneo/${id}`;
export const urlTournamentConfirmRegister = () => `/confirm-registration`;
//
//
// Product URLs
export const urlProductList = (clubId: string) => `/club/${clubId}/productos`;
export const urlCreateProduct = (clubId: string) => `/club/${clubId}/productos/nuevo`;
export const urlEditProduct = (clubId: string, productId: string) =>
  `/club/${clubId}/productos/${productId}`;
export const urlCategoryList = (clubId: string) => `/club/${clubId}/productos/categorias`;
export const urlStock = (clubId: string) => `/club/${clubId}/productos/stock`;
export const urlActivateStock = (clubId: string) => `/club/${clubId}/productos/stock/activar`;
export const urlStockEntry = (clubId: string) => `/club/${clubId}/productos/stock/ingresar`;
export const urlEditCategory = (clubId: string, categoryId: string) =>
  `/club/${clubId}/productos/categorias/${categoryId}`;
export const urlSales = (clubId: string) => `/club/${clubId}/ventas`;
//
//
// Player URLs
export const urlPlayerList = (clubId: string) => `/club/${clubId}/jugadores`;
//
//
// Open Matches URLs
export const urlOpenMatches = (clubId: string) => `/club/${clubId}/partidos-abiertos`;
export const urlPublicOpenMatch = (matchId: string) => `/partido/${matchId}`;
//
//
// Sponsor URLs
export const urlSponsors = (clubId: string) => `/club/${clubId}/sponsors`;
//
//
// Screen URLs
export const urlScreenList = (clubId: string) => `/club/${clubId}/pantallas`;
export const urlScreen = (clubId: string, screenId: string) =>
  `/club/${clubId}/pantallas/${screenId}`;
// What a TV opens: it has no session and no club in its URL. A screen's page
// opens it with the screen, for a TV plugged into that same computer.
export const urlScreenDevice = (screenId?: string) =>
  screenId ? `/tv?pantalla=${screenId}` : `/tv`;
//
//
// Cashier Mode URLs
export const urlCashierMode = (clubId: string) => `/club/${clubId}/caja`;
//
//
// Tournament Mode URLs
export const urlTournamentMode = (clubId: string, tournamentId: string) =>
  `/club/${clubId}/modo-torneo/${tournamentId}`;
export const urlTournamentModeCourts = (clubId: string, tournamentId: string) =>
  `${urlTournamentMode(clubId, tournamentId)}/canchas`;
